import { render, staticRenderFns } from "./ABackupcodeOtp.vue?vue&type=template&id=2d24e5ae&"
import script from "./ABackupcodeOtp.vue?vue&type=script&lang=js&"
export * from "./ABackupcodeOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports